export default __webpack_public_path__ + "static/media/average-resale-price.c3fafdea.svg";